module.exports = __webpack_public_path__ + "img/add-fabric.1fd325f1.svg";